import "../../styles/loading.css";

export const AppLoader = () => {
    return (
        <div className="full-cnt-pg">
            <div className="loading">
                <img src="/logos/rwt.png" width={45} height={45} />
                <div className="load-txt">Loading...</div>
            </div>
        </div>
    )
}